import { render, staticRenderFns } from "./ExamAttributeContentGroup.vue?vue&type=template&id=bec0e7e6&scoped=true&"
import script from "./ExamAttributeContentGroup.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeContentGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeContentGroup.vue?vue&type=style&index=0&id=bec0e7e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec0e7e6",
  null
  
)

export default component.exports